import React from 'react';
import './Spinner.css';

export function Spinner({ size = 'md', className = '' }) {
  return <span className={`ui-spinner ui-spinner--${size} ${className}`} />;
}
